import styled from "@emotion/styled";

import { AdSlotContainer as StyledAdSlotContainer } from "~/components/advertisement/ad-slots/ad-slot/styles";

export const AdCardContainer = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
  min-block-size: fill-available;
`;

type AdSlotContainerProps = {
  $isHidden: boolean;
};
export const AdSlotContainer = styled.div<AdSlotContainerProps>`
  position: absolute;

  display: ${props => (props.$isHidden ? "none" : "flex")};

  inline-size: 100%;

  && ${StyledAdSlotContainer} {
    /* stylelint-disable-next-line csstree/validator */
    min-inline-size: min(calc((80vh * (3 / 4))), 100%);
  }
`;
